export const PageHeader = ({ title, subtitle, actions }) => (
  <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="font-heading text-2xl font-extrabold tracking-tight sm:text-3xl" data-testid="page-title">
        {title}
      </h1>
      {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export const KpiCard = ({ label, value, icon: Icon, tone = "text-primary", hint, testId }) => (
  <div className="flex flex-col justify-between rounded-xl border bg-card p-4 shadow-sm transition-shadow hover:shadow-md sm:p-5" data-testid={testId}>
    <div className="flex items-center justify-between gap-2">
      <span className="text-xs font-medium text-muted-foreground sm:text-sm">{label}</span>
      {Icon && <Icon className={`h-4 w-4 shrink-0 ${tone}`} />}
    </div>
    <div className={`mt-2 font-mono text-xl font-semibold tracking-tight sm:text-2xl ${tone}`} data-testid={testId && `${testId}-value`}>
      {value}
    </div>
    {hint && <span className="mt-1 text-xs text-muted-foreground">{hint}</span>}
  </div>
);

export const Field = ({ label, children, hint, className = "" }) => (
  <label className={`block space-y-1.5 ${className}`}>
    <span className="text-sm font-medium">{label}</span>
    {children}
    {hint && <span className="block text-xs text-muted-foreground">{hint}</span>}
  </label>
);

export const NativeSelect = ({ className = "", children, ...props }) => (
  <select
    className={`flex h-10 w-full rounded-md border border-input bg-background px-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${className}`}
    {...props}
  >
    {children}
  </select>
);
